import FormWalletAddressActions from '../form/wallet-address/Form.WalletAddressActions';
import FormWalletAddressInputs from '../form/wallet-address/Form.WalletAddressInputs';

const DialogWithdrawUsdAddWalletAddress = () => (
	<div className='payment-request-form_usdDestination_send-crypto'>
		<FormWalletAddressInputs />

		<FormWalletAddressActions variant='save-address' />
	</div>
);

export default DialogWithdrawUsdAddWalletAddress;
